import React from 'react'
import {Link} from 'react-router-dom'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'

export default function ErrorWishlistServices () {
    return(
        <div className="errorProductServices">
            <img src={`${BASE_PATH}${SUB_DIRECTORY}img/empty_wish_list.svg`} alt="Página no encontrada" width="450" height="450" loading="lazy"/>
            <p className="titleError">¡Lista vacía!</p>
            <p className="suggestion">Toca el corazón para agregar los productos que más te gusten.</p>
            <Link className="btn rojo" to={`/`} title="Ir al inicio">Agregar Productos</Link>
        </div>
    )
}